import { locationNotificationRecipientDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const recipientSchema = dataEnvelopeSchema(locationNotificationRecipientDTOSchema);
const recipientListSchema = dataEnvelopeSchema(z.array(locationNotificationRecipientDTOSchema));
function listPath(locationId) {
    return `${WEB_API_PREFIX}/visitor/locations/${encodeURIComponent(locationId)}/notification-recipients`;
}
export function createLocationNotificationRecipientsResource(transport) {
    return {
        async list(locationId) {
            const envelope = await transport.request({
                path: listPath(locationId),
                schema: recipientListSchema,
            });
            return envelope.data;
        },
        async add(locationId, input) {
            const envelope = await transport.request({
                method: 'POST',
                path: listPath(locationId),
                schema: recipientSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(locationId, id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${listPath(locationId)}/${encodeURIComponent(id)}`,
                schema: recipientSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(locationId, id) {
            await transport.request({
                method: 'DELETE',
                path: `${listPath(locationId)}/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
    };
}
//# sourceMappingURL=location-notification-recipients.js.map